import {Component, OnInit} from '@angular/core';
import {SubscriptionService} from '../../../shared/services/subscription.service';
import {AuthService} from '../../../shared/services/auth.service';
import {properties} from '../../../../environments/properties';
import {ParamService} from '../../../shared/services/param.service';
import {_windowUtil, findNestedObj} from '../../../shared/utils/ui-utils';
import {Observable, of} from 'rxjs';
import {map, shareReplay} from 'rxjs/operators';
import {RegistrationSubscriptionService} from '../../../shared/services/registration-subscription.service';
import { ActivatedRoute, Router } from '@angular/router';

declare let $: any;

@Component({
    selector: 'app-snap-landing-page',
    templateUrl: './snap-landing-page.component.html',
    styleUrls: ['./snap-landing-page.component.scss'],
    providers: [SubscriptionService, RegistrationSubscriptionService],
})
export class SnapLandingPageComponent implements OnInit {
    public plans$: Observable<any>;
    userInfo: any;
    plansResponse: any;
    isLoggedInTokenValid: Boolean;
    currentEnvironment;
    freshpassTilesComponent;
    frequentlyAskedQuestion;
    termsContent;
    showFrequentlyAskedQuestion = false;
    showTermsContent = false;
    snapBenefitsJSON: any;
    banner;
    isB2B;
    public enableSnap: Boolean;
    public windowUtil = _windowUtil(window);
    isPlanLoaded = false;
    easyStepsComponent;
    showEasyStepsComponent: boolean = false;

    constructor(
        public subscriptionService: SubscriptionService,
        public registrationSubscriptionService: RegistrationSubscriptionService,
        public authService: AuthService,
        public paramService: ParamService,
        private activeRoute: ActivatedRoute,
        private router: Router,
    ) {
      this.banner = this.paramService.banner;
    }

    ngOnInit(): void {
        this.isB2B = this.authService.checkB2B();
  
        //disable snap on b2b site
        this.enableSnap = this.isB2B ? false : properties.featureFlags.enableSnap;
  
        if (this.enableSnap) {
            this.currentEnvironment = this.subscriptionService.getEnvironment();
            this.getFreshPassBenefits(this.currentEnvironment);

            this.authService.getUserLogedInToken();
            this.authService.populateSessionData$.subscribe((userInfo) => {
                if (userInfo) {
                    this.userInfo = userInfo;
                    this.getPromotionPlans();
                    //FOR FUTURE REFERENCE IF USER IS LOGGED IN TO DO USEFUL STUFF
                    if (userInfo.isTokenValid) {
                        this.isLoggedInTokenValid = true;
                    } else {
                        this.isLoggedInTokenValid = false;
                    }
                }
            });
            this.fetchEasyStepsFragment();
            this.subscriptionService
                .getFrequentlyAskedComponent(this.currentEnvironment)
                .subscribe((data) => {
                    if (data) {
                        this.frequentlyAskedQuestion = data;
                        this.showFrequentlyAskedQuestion = true;
                        setTimeout(() => {
                            $('.accordion-header').toggleClass('inactive-header');
                            $('.display-type').each(function () {
                                let displayType = $(this).attr('data-display-type');
                                if (displayType == 'expandFirst') {
                                    $(this)
                                        .find('.accordion-header')
                                        .first()
                                        .toggleClass('active-header')
                                        .toggleClass('inactive-header');
                                    $(this)
                                        .find('.accordion-content')
                                        .first()
                                        .slideDown()
                                        .toggleClass('open-content');
                                } else if (displayType == 'expanded') {
                                    $(this)
                                        .find('.accordion-header')
                                        .toggleClass('active-header')
                                        .toggleClass('inactive-header');
                                    $(this)
                                        .find('.accordion-content')
                                        .slideDown()
                                        .toggleClass('open-content');
                                }
                            });

                            // The Accordion Effect
                            $('.accordion-header').each(function () {
                                if ($(this).hasClass('active-header')) {
                                    $('.accordion-header').attr('aria-expanded', 'true');
                                } else {
                                    $(this).attr('aria-expanded', 'false');
                                }
                            });

                            $('.accordion-header').click(function () {
                                if ($(this).is('.inactive-header')) {
                                    $(this)
                                        .toggleClass('active-header')
                                        .toggleClass('inactive-header');
                                    $(this).attr('aria-expanded', 'true');
                                    $(this).next().slideToggle().toggleClass('open-content');
                                } else {
                                    $(this)
                                        .toggleClass('active-header')
                                        .toggleClass('inactive-header');
                                    $(this).attr('aria-expanded', 'false');
                                    $(this).next().slideToggle().toggleClass('open-content');
                                }
                            });

                            $('.accordion-header').keypress(function (e) {
                                let key = e.which;
                                if (key == 13) {
                                    if ($(this).is('.inactive-header')) {
                                        $(this)
                                            .toggleClass('active-header')
                                            .toggleClass('inactive-header');
                                        $(this).attr('aria-expanded', 'true');
                                        $(this).next().slideToggle().toggleClass('open-content');
                                    } else {
                                        $(this)
                                            .toggleClass('active-header')
                                            .toggleClass('inactive-header');
                                        $(this).attr('aria-expanded', 'false');
                                        $(this).next().slideToggle().toggleClass('open-content');
                                    }
                                }
                            });
                        }, 2000);
                    }
                });
            this.subscriptionService
                .getTermsComponent(this.currentEnvironment)
                .subscribe((data) => {
                    if (data) {
                        this.termsContent = data;
                        this.showTermsContent = true;
                    }
                });
        } else {
            this.redirectToSubscribe();
        }
    }

    fetchEasyStepsFragment() {
      this.subscriptionService.fetchAEMEasySteps(this.currentEnvironment).subscribe(data => {
        if (data) {
          this.easyStepsComponent = data;
          this.showEasyStepsComponent = true;
        }
      });
    }

    getFreshPassBenefits = (currentEnv): void => {
        this.subscriptionService.getFreshPassBenefitsJSONAPI(currentEnv).then(
            (response) => {
                const tileObj = findNestedObj(response, 'freshpasstileparsys');
                if (tileObj) {
                    this.snapBenefitsJSON = tileObj;
                }
            },
            (error) => {
                console.error(`error fetching experience fragment ${error}`);
            }
        );
    };

    getPromotionPlans() {
        this.getPlans().subscribe({
            next: (response) => {
                this.plansResponse = response;
                this.isPlanLoaded = true;
            },
            error: (error) => {
                this.isPlanLoaded = true;
                if (error?.error && error?.error?.errorCode) {
                    this.handleErrorCode(error.error.errorCode)
                }
            }
        });
    }

    getPlans() {
        const promoDiscountCode = undefined;
        if (!this.plans$) {
            this.plans$ = this.registrationSubscriptionService
                .getPlans(promoDiscountCode, this.userInfo);
        }
        return this.plans$;
    }

    handleErrorCode(errorCode) {
        this.redirectToSubscribe();
    }

    redirectToSubscribe() {
        const queryParams = this.activeRoute.snapshot.queryParams;
        this.router.navigate([properties.urlPath.SUBSCRIBE_PATH], { queryParams });
    }
}
